import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { ConfigurationPage } from "../../configuration/configuration";
import { SuperPage } from "../../auth/super/super";
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { MultiPage } from '../../auth/multi/multi';
import { ProvidersServices } from '../../providers/services';
import { HomeTeacherPage } from '../../schools/home-teacher/home-teacher';
import { SchoolServices } from '../../schools/services';
import { BlockScreenPage } from '../block-screen/block-screen';
import { OrdersLoaderPage } from '../../orders/orders-loader/orders-loader';
import { LoginPage } from '../../auth/login/login';
import { HomePrincipalPage } from '../../schools/home-principal/home-principal';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsServices } from '../../services/notificationsServices';

/**
 * Generated class for the HeaderSchoolPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-header-school',
  templateUrl: 'header-school.html',
})
export class HeaderSchoolPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public afAuth: AngularFireAuth,
    private globals: Globals,
    public configurationServices: ConfigurationServices,
    public providersServices: ProvidersServices,
    public schoolServices: SchoolServices,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public translate: TranslateService,
    public notificationsServices: NotificationsServices) {

  }

  openHome() {

    if (this.globals.user_type === 'principal') {
      this.navCtrl.setRoot(HomePrincipalPage);
    } else if (this.globals.user_type === 'teacher') {
      this.navCtrl.setRoot(HomeTeacherPage);
    }
  }

  openConfig() {
    this.navCtrl.setRoot(ConfigurationPage);
  }

  openSuper() {
    this.navCtrl.push(SuperPage);
  }

  openMulti() {
    this.navCtrl.push(MultiPage);
  }

  openTeacherHome() {
    this.schoolServices.enter_rest = false;
    this.navCtrl.setRoot(HomeTeacherPage);
  }


  openOrdersRooms() {
    this.globals.side_menu_active = 'order';
    this.navCtrl.setRoot(OrdersLoaderPage);
  }

  blockscreen() {
    this.navCtrl.setRoot(BlockScreenPage, {
      type: 'orders',
    });
  }
  logout() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-cerrar-sesion'),
      message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.delNotTokenAndLogout();
          }
        }
      ]
    });
    alert.present();
  }


  async delNotTokenAndLogout() {
    //funcion que borra token
    await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
    //hacemos logout de afAuth
    this.afAuth.auth.signOut()
      .then(authData => {
        // toast message
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cerrado-sesion'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
          this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
        }

        this.navCtrl.setRoot(LoginPage);
        window.location.reload();
      }, error => {
        //var errorMessage: string = error.message;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/header-school/header-school.ts